var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 26,
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54474e-05 12.7671C3.54608e-05 12.4618 0.057289 12.1656 0.171793 11.8786C0.286296 11.5916 0.438967 11.3534 0.629806 11.1641L11.1641 0.629768C11.584 0.209922 12.1183 -1.25962e-07 12.7672 -9.75996e-08C13.416 -6.92373e-08 13.9504 0.209922 14.3702 0.629768C14.7901 1.04961 15 1.58397 15 2.23282C15 2.88167 14.7901 3.41602 14.3702 3.83587L5.43895 12.7671L14.3702 21.6984C14.7901 22.1183 15 22.6526 15 23.3015C15 23.9503 14.7901 24.4847 14.3702 24.9045C13.9504 25.3244 13.416 25.5343 12.7672 25.5343C12.1183 25.5343 11.584 25.3244 11.1641 24.9045L0.629806 14.3702C0.400799 14.1412 0.238203 13.8931 0.14202 13.6259C0.0458375 13.3587 -0.00149128 13.0725 3.54474e-05 12.7671Z",
    fill: "#5AB2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.afa3bb191f081a827381c15e4ea52f30.svg";
export { ForwardRef as ReactComponent };